import { z } from 'zod';
import type { ApiContract } from '../contracts';
import { OrganizationSummarySchema } from './organizations';

/**
 * Finalizes onboarding after the email is verified: the server accepts any
 * pending invite(s) for the user's email (creating memberships at the invited
 * role, deleting the invite, notifying the inviter) and reports whether the user
 * now belongs to an organization. The client routes to the dashboard when
 * `hasOrg` is true, or to the create-organization step otherwise.
 */
export const CompleteOnboardingResponseSchema = z.object({
  hasOrg: z.boolean(),
  organization: OrganizationSummarySchema.nullable(),
  acceptedInviteCount: z.number().int().nonnegative(),
});
export type CompleteOnboardingResponse = z.infer<typeof CompleteOnboardingResponseSchema>;

export const completeOnboardingContract = {
  method: 'POST',
  path: '/api/onboarding/complete',
  response: CompleteOnboardingResponseSchema,
} as const satisfies ApiContract;
